'use strict'

{isFeatureEnabled, checkSetting} = require '../../../page/frontend/helpers/finch'
isScrolledPastElement = require '../../../page/frontend/helpers/is_scrolled_past_element'
{getParameterByName} = require '../../../page/frontend/helpers/query_params'

module.exports = class ScrollDepthView
  constructor: ->
    return if @_isSearchPage()
    @_addScrollDepthScrollListener()
    if checkSetting('addScrollDepthOnBrowse')
      @_renderScrollDepthElement()

  _renderScrollDepthElement: ->
    scrollDepthElement = document.createElement('div')
    scrollDepthElement.style.height = '347px'

    document.getElementById('global-container')?.append(scrollDepthElement)

  _addScrollDepthScrollListener: ->
    cardContainer = document.querySelector('#pull-widget')

    if isScrolledPastElement(cardContainer)
      isFeatureEnabled('addScrollDepthOnBrowse')
    else
      @_handleScrollDepthBucketing = =>
        if isScrolledPastElement(cardContainer)
          isFeatureEnabled('addScrollDepthOnBrowse')
          window.removeEventListener('scroll', @_onScrollForScrollDepth)

      @_onScrollForScrollDepth = _.debounce(@_handleScrollDepthBucketing, 200)
      window.addEventListener('scroll', @_onScrollForScrollDepth)

  _isSearchPage: ->
    getParameterByName('query') != null

